export default __webpack_public_path__ + "static/media/WMOVR.ec2f4b8e.png";